import styled from 'styled-components';

export const ModelRuleItem = styled.li`
  .tooltip-content {
    max-width: 75%;
    line-break: loose;
  }
`;
